import './lib/uuid';
import { Factory } from 'rosie';

Factory.define('ChannelConfiguration');

Factory.define('ChannelConfigurationWithDefaults')
  .extend('ChannelConfiguration')
  .attr('endpoints', () => [
    Factory.attributes('ChatEndpoint'),
    Factory.attributes('EmailEndpoint', { address: 'support@company.com' }),
    Factory.attributes('EmailEndpoint', { address: 'billing@company.com' }),
    Factory.attributes('InstagramDirectEndpoint'),
    Factory.attributes('SmsEndpoint'),
    Factory.attributes('VoiceEndpoint'),
    Factory.attributes('WhatsAppEndpoint'),
  ]);



// WEBPACK FOOTER //
// ./factories/channel_configuration_factory.js